import React, { useEffect, useState } from 'react';
import { isValidStartEndTime } from  '@/helpers/Planner';
import { plannerEvent } from  '@/interfaces/planner';
import  '@/css/eventTime.scss'



const EventTme = (
    {startTime, setStartTime, endTime,  setEndTime, readOnly, calDate, event} :
    {startTime:string, setStartTime:(time:string) => void, endTime:string, setEndTime:(time:string) => void, readOnly:boolean, calDate:Date[], event?:plannerEvent}) => {

    const [timeError, setTimeError] = useState<boolean>(false)

    useEffect(() => {

        // No validation on edit currently
        if (event) return

        if (isValidStartEndTime(startTime, endTime, calDate)){
            setTimeError(false)
        }
        else{
            setTimeError(true)
        }

    }, [startTime, endTime, calDate])


    return (
        <div className={`time-selectors`}>
            <input 
                aria-label="Select Start Time"
                className={`${timeError ? 'time-error' : ''}`} 
                type="time" 
                onChange={(e) => setStartTime(e.target.value)} 
                value={startTime} 
                readOnly={readOnly} 
            />
           
            <div className='spacer'>-</div>

            <input 
                aria-label="Select Finish Time"
                className={`${timeError ? 'time-error' : ''}`} 
                type="time" 
                onChange={(e) => setEndTime(e.target.value)} 
                value={endTime} 
                readOnly={readOnly} 
            />
        </div>
    );
};

export default EventTme;